module.exports = __webpack_public_path__ + "static/media/diners.304339cc.svg";